<template>
    <div class="container">
        <div class="section">
            <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/business/h5/1%402x.png">
        </div>

        <div class="ceiling-view" v-if="ceilingType">
            <div class="ceiling-tab" :class="{'ceiling-fixed':ceilingType}">
                <van-tabs v-model="activeTab" :swipe-threshold="4" @click="tabChange">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="item.stage" >
                    </van-tab>
                </van-tabs>
                <div class="box"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220713/1657680863798.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657680875313.png">
        </div>
        <div class="section" id="section_0">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657680890634.png">
        </div>
        <div class="section" id="section_1">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657680902741.png">
        </div>
        <div class="section-main">
            <div class="s-main">
                <van-tabs v-model="active">
                    <van-tab v-for="(item, index) in stageList" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="text-title">学习目标</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="text-title">核心内容</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div v-if="item.skillsContent.length" class="title title1">
                                <div class="text-title">核心技术</div>
                            </div>
                            <div v-if="item.skillsContent.length" class="content">
                                <div v-for="(val,ind) in item.skillsContent" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>

                <div class="tips-tab">
                    【具体课程内容以实际课程安排和进度为准】
                </div>
            </div>
            <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                <img class="botton_img" src="https://s20.lgstatic.com/growth/activity/20220713/1657683842855.png">
                <div class="tips-box">
                    <img
                        class="tips-img"
                        src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                    >
                </div>
            </button>
        </div>
        <div class="section-main-2" id="section_2">
            <div class="section-title">3大名企热门项目实战</div>
            <div class="s-main">
                <van-tabs v-model="active2">
                    <van-tab v-for="(item, index) in projectsDetail" :key="index" :title="item.title" class="tb">
                        <div class="t-title">
                            {{item.projectTitle}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="tabs-content">
                            <div class="tab-item" v-for="(detail, j) in item.details" :key="j">
                                <div class="tab-title">{{ detail.title }}</div>
                                <div v-if="detail.txt" class="tab-txt">{{ detail.txt }}</div>
                                <template v-if="detail.txts && detail.txts.length">
                                    <div v-for="(txt, m) in detail.txts" :key="m" class="tab-txt tab-txt2">{{ txt }}</div>
                                </template>
                            </div>
                        </div>
                        <div class="tab-img-wrap">
                            <img v-for="(img, k) in item.projectImgs" :key="k" class="tab-img" :src="img" alt="">
                        </div>
                    </van-tab>
                </van-tabs>

                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
            <button class="stage-more" @click="JumpFn('获取更多项目资料')">
                <img class="botton_img" src="https://s20.lgstatic.com/growth/activity/20220704/1656917038421.png">
                <div class="tips-box">
                    <img
                        class="tips-img"
                        src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                    >
                </div>
            </button>
        </div>
        <!-- <div class="section">
            <div class="swiper-container current-container3" id="sw-section2">
                <div class="swiper-wrapper current-wraps">
                    <div
                        v-for="(value,inde) in swiperListNew1"
                        :key="inde"
                        class="swiper-slide current-box"
                    >
                        <img class="company" :src="value"/>
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div> -->
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <div class="box10-right img pay-btn-wrapper">
            <div class="pay-btn">
              <img
                style="width: 100%;"
                src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/data_enhancement/mobile/%E7%BC%96%E7%BB%84%208%402x.png"
                alt="">
            </div>
          </div>
            <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
            <div class="img-box">
                <img
                    class="img-btns"
                    src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                >
            </div>
            <FooterPoup
                :id="82"
                :isDcsj="false"
            />
        </button>

        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div :class="{'modal-content': true, active: modalVisable && modalType == 'text', 'active-img': modalVisable && modalType != 'text'}">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div v-if="modalType == 'text'">
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="content-img">
                        <img :src="current" />
                    </div>
                </div>
            </div>
        </div>
        <RetainModal
            :visible="retainModalVisible"
            @removeHash="removeHash"
            pageId="1qb3"
        />
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Tab, Tabs } from 'vant';
import activity from '../../../common/activity';
Vue.use(Tab);
Vue.use(Tabs);
import List from './data.js'
import RetainModal from '../../../components/RetainModal/index.vue'
import { postIsBuyCourse } from '../../../service/api'
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion'
// // ios
// window.appBeforeGoBack = function () {
//     window.location.hash = 'showModal'
//     return 0
// }
// // android
// if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
//     window.appBeforeUnLoaded = function () {
//         window.location.hash = 'showModal'
//         return true
//     }
// }
export default {
    name: 'JavaJaGouShiH5',
    data() {
        return {
            activity,
            List,
            imgObj:{},
            imgList:[],
            imgList1:[],
            swiperList:[],
            swiperList1:[],
            swiperList2:[],
            swiperList3:[],
            ceilingType:false,//吸顶tab
            activeTab:0,
            modalVisable:false,
            moadlData:{},
            tabList:[],
            stageList:[],
            retainModalVisible: false,
            canShowModal: false,
            swiperListNew: [
                "https://s21.lgstatic.com/growth/activity/20220705/1657009909984.png",
                "https://s20.lgstatic.com/growth/activity/20220705/1657009938332.png",
                "https://s21.lgstatic.com/growth/activity/20220705/1657009945452.png",
                "https://s21.lgstatic.com/growth/activity/20220705/1657009953190.png",
            ],
            swiperListNew1: [
                "https://s20.lgstatic.com/growth/activity/20220713/1657693232513.png",
                "https://s21.lgstatic.com/growth/activity/20220713/1657693240619.png",
                "https://s20.lgstatic.com/growth/activity/20220713/1657693249510.png",
                "https://s21.lgstatic.com/growth/activity/20220713/1657693259932.png",
            ],
            projectsDetail: [],
            addressIdsMap: {
                "领取完整课程安排": "r1tyx",
                "获取更多项目资料": "s1tyy",
                "名额有限立即抢占": "t1tyz"
            }
        };
    },
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        RetainModal
    },
    mounted() {
        let dataList = this.List.data;
        this.imgObj = dataList.h5.imgObj
        this.imgList = dataList.h5.imgList
        this.imgList1 = dataList.h5.imgList1
        this.swiperList = dataList.h5.swiperList
        this.swiperList1 = dataList.h5.swiperList1
        this.swiperList2 = dataList.h5.swiperList2
        this.swiperList3 = dataList.h5.swiperList3

        this.tabList = dataList.tabList
        this.stageList = dataList.stageList
        this.projectsDetail = dataList.projectsDetail

        // this.watchHashChange()
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1qb3' });
            this.platTrack('h5pv', {
                page_id: 'c1tyi',
            })
            this.swiperInit()
            this.renderSwipers()
        },500)
        // window.addEventListener('scroll', this.scrollTopFn)
    },
    destroyed () {
        // window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 370 ? true : false; //吸顶tab
            let arr = [
                "section_0",
                "section_1",
                "section_2",
                "section_3",
                "section_4"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 100) {
                    this.activeTab = index
                }
            })
        },
        tabChange(val,title) {
            let arr = [
                "#section_0",
                "#section_1",
                "#section_2",
                "#section_3",
                "#section_4"
            ]
            this.$el.querySelector(arr[val]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1qb3',
                'button_name': title
            });
        },
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qb3',
            //     'button_name': '领取详细课程大纲'
            // });
            str && this.platTrackClickFn(str)
            setTimeout(() => {
                handleJumpUrl(`ed1890dd539543ef9f01d38018e5d3d0`);
            }, 200);
        },
        watchHashChange() {
            const that = this
            window.addEventListener('hashchange', function(e) {
                postIsBuyCourse().then(res => {
                    if (res.state == 1) {
                        if (res.content) {
                            window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                        } else {
                            that.canShowModal = !res.content
                            if (window.location.hash == '#showModal' && that.canShowModal) {
                                that.retainModalVisible = true
                            }
                        }
                    }
                })
            })
        },
        removeHash() {
            this.retainModalVisible = false
            this.canShowModal = false
            window.location.hash = ''
        },
        getTags(item){
            this.modalType = 'text';
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;width:100%;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 2000,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 2000,
                spaceBetween: 30,
                // pagination: '.current-pagination',
            };
            this.$nextTick(() => {
                const swiper = new Swiper('.wrap-current', option);
                const swiper1 = new Swiper('.current', option);
                const swiper2= new Swiper('.wrap', option1);
            });
        },
        renderSwipers() {
            let that = this;
            let option = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                // onClick(e){
                //     that.getSlide(e.realIndex)
                // }
            };
            const swiper = new Swiper('.current-container', option);
            let option2 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                onClick(e){
                    that.getSlide(e.realIndex)
                }
            };
            const swiper2 = new Swiper('.current-container2', option2);
            let option3 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10
            };
            const swiper3 = new Swiper('.current-container3', option3);
        },
        platTrackClickFn(name) {
            this.platTrack('h5click', {
                page_id: 'c1tyi',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    background: #F4F4F4;
    padding-bottom: 150px;
    .section {
        position: relative;
        width: 100%;
        .section-line {
            position: absolute;
            bottom: 26px;
            left: 0;
            width: 1px;
            height: 1px;
        }
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .current-container {
            width: 100%;
            position: absolute;
            height: 202px;
            bottom: 230px;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .current-container2 {
            width: calc(100% - 60px);
            height: 590px;
            position: absolute;
            top: 380px;
            left: 34px;
            .current-wraps {
                width: 520px;
                position: absolute;
                // padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .current-container3 {
            width: calc(100% - 30px);
            height: 674px;
            .current-wraps {
                width: 357px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:357px !important;
                    // margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .wrap {
            width: 690px;
            height: 647px;
            .swiper-wrapper {
                width:100% !important;
                img {
                    width: 100%;
                }
            }
        }
    }
    .ceiling-view {
        width: 100%;
        // height: 94px;
        // margin: 0px 0 40px;

        .ceiling-tab {
            position: relative;
            width: 100%;
            height: 94px;
            background: #FFFFFF;
            box-shadow: 0px 6px 8px 0px rgba(71, 68, 85, 0.08);
            z-index: 33;
            // /deep/ .van-tabs__wrap--scrollable{
            // height: 94px;
            // }
            .box {
                position: absolute;
                top: 0;
                right: 0;
                width: 60px;
                height: 94px;
                background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
            }
            /deep/ .van-tabs__nav {
                position: relative;
            }
            // /deep/ .van-tabs__wrap {
            //     height: 94px;
            // }
            /deep/ .van-tab {
                position: relative;
                width: 200px;
                height: 94px;
                color: #32355C;
                font-size: 30px;
                font-weight: 400;
            }
            /deep/.van-tab--active {
                box-sizing: border-box;
                color: #32355C;
                font-weight: 400;
                &::before{
                    content: '';
                    width: 32px;
                    height: 32px;
                    background: url('https://s20.lgstatic.com/growth/activity/20210915/1631674560435.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 16px;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
                .van-tab__text {
                    padding-left: 24px;
                }
            }
            /deep/ .van-tabs__line {
                // bottom: 40px;
                background: linear-gradient(293deg, #58BEFF 0%, #1573EB 100%);
                width: 160px;
                height: 6px;

            }
        }
        .ceiling-fixed {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 30;
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        margin-bottom: 100px;
        .stage-more {
            position: absolute;
            bottom: -45px;
            left: 50%;
            transform: translate(-50%);
            width: 422px;
            background-color:transparent;
            border: none;
            z-index: 9;
            overflow: hidden;
            .botton_img {
                width: 100%;
                display: block;
            }
        }
        .s-main {
            position: relative;
            margin: 0 auto;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 130px;
            box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            overflow: hidden;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                overflow: hidden;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #6469A7;
                    font-weight: 500;
                    padding: 25px 60px 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #6469A7;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        position: relative;
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .text-title {
                        position: relative;
                        height: 46px;
                        text-align: center;
                        line-height: 46px;
                        margin-left: 40px;
                        padding-left: 20px;
                        &::before {
                            content: "";
                            position: absolute;
                            top: 12px;
                            left: 0;
                            width: 6px;
                            height: 22px;
                            background-image: linear-gradient(-41deg, #80FDFE 0%, #7EF3FE 15%, #64B1FF 97%);
                        }
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210915/1631689227229.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
            .tips-tab {
                position: absolute;
                bottom: 60px;
                width: 100%;
                color: rgba(14, 19, 82, .2);
                text-align: center;
                font-size: 12px;
            }

        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(329deg, #02AE96 0%, #16E4C5 100%);
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 200px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
    }
    .sw-section {
        /deep/ .wrap-current {
            width: 9.2rem;
            height: 13.1rem;
            .swiper-wrapper {
                width: 9.173rem;
                img {
                    width: 100%;
                }
            }
            .swiper-pagination-bullet {
                border-radius: 50%;
                width: 0.2rem;
                height: 0.2rem;
                background: #1220FF;
                opacity: 0.5;
                // margin: 0 0.093rem;
                &-active {
                    width: 0.4rem;
                    height: 0.2rem;
                    background: #1220FF;
                    border-radius: 0.2rem;
                    opacity: 1;
                }
            }
        }
    }
    .sw1-section {
         /deep/ .current {
            width: 9.2rem;
            height: 9.9rem;
            .swiper-wrapper {
                width: 9.173rem;
                img {
                    width: 100%;
                }
            }
            .swiper-pagination-bullet {
                border-radius: 50%;
                width: 0.2rem;
                height: 0.2rem;
                background: #1220FF;
                opacity: 0.5;
                // margin: 0 0.093rem;
                &-active {
                    width: 0.4rem;
                    height: 0.2rem;
                    background: #1220FF;
                    border-radius: 0.2rem;
                    opacity: 1;
                }
            }
        }
    }

    .layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 180px;
        z-index: 10;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s linear;
            overflow-y: scroll;
            &.active {
                opacity: 1;
                height: 962px;
                overflow: hidden;
            }
            &.active-img {
                opacity: 1;
                height: 662px;
                overflow: hidden;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;
            margin-right: 45px;
            box-sizing: border-box;
        }
        .close {
            width: 42px;
            height: 42px;
            background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
            background-size: 42px 42px;
            position: absolute;
            right: 30px;
            top: 30px;
            border-radius: 50%;
            z-index: 1;
        }
        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }
        .content {
            height: 755px;
            overflow-y: scroll;
        }
        .content-title {
            margin-bottom: 20px;
            font-weight: bold;
            color: #191F34;
            position: relative;
            padding-left: 47px;
            font-size: 26px;
            line-height: 28px;
            padding-right: 30px;
            &:before {
                content: '';
                width: 8px;
                height: 8px;
                background: #C69C6D;
                border-radius: 8px;
                position: absolute;
                left: 25px;
                top: 11px;
            }
        }
        .content-desi {
            margin-bottom: 48px;
            color: #5E6476;
            font-size: 26px;
            padding-left: 48px;
            padding-right: 30px;
        }
        .content-img {
            width: 100%;
            height: 100%;
            overflow-y: scroll;
        }
        .content-img img{
            width: 100%;
            margin: 0px auto;
            display: block;
        }
    }
    .tips-box {
        position: absolute;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        .tips-img {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2.2s infinite linear;
            display: block;
            height: 100%;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);
        .pay-btn-wrapper {
          box-sizing: border-box;
          width: 750px;
          height: 158px;
          background-color: #fff;
          padding-top: 26px;
          .pay-btn {
            width: 90%;
            margin: 0 auto;
            height: 87px;
            line-height: 87px;
            color: #fff;
            border-radius: 30px;
            background-image: linear-gradient(90deg,  #fe5686, #ff8d5f);
          }
        }
        .img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
        .img-box {
            position: absolute;
            top: 10px;
            left: 0;
            width: 100%;
            height: 100px;
        }
        .img-btns {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2s infinite linear;
            width: 224px;
            height: 120px;
        }
    }

    @keyframes left {
        0% {
            left: -50%;
        }
        50% {
            left: 100%;
        }
        100% {
            left: 200%;
        }
    }
}
.section-main-2 {
    position: relative;
    width: 100%;
    margin-bottom: 100px;
    // top: 200px;
    // left: 0;
    .section-title {
        font-family: SourceHanSansCN-Bold;
        font-weight: Bold;
        font-size: 42px;
        color: #43445F;
        line-height: 48px;
        padding-left: 30px;
    }
    .stage-more {
        position: absolute;
        bottom: -45px;
        left: 50%;
        transform: translate(-50%);
        width: 422px;
        background-color:transparent;
        border: none;
        z-index: 9;
        overflow: hidden;
        .botton_img {
            width: 100%;
            display: block;
        }
    }
    .s-main {
        position: relative;
        margin: 24px auto 0;
        width: 688px;
        background-color: #fff;
        z-index: 2;
        border-radius: 8px;
        padding-bottom: 150px;
        box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        overflow: hidden;
        .tb {
            position: relative;
            width: 100%;
            background-color: #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            overflow: hidden;
            .t-title {
                text-align: center;
                font-size: 32px;
                color: #6469A7;
                font-weight: 500;
                padding: 25px 0 10px;
            }
            .t-icon {
                width: 688px;
                display: block;
                height: 2px;
            }
            .target {
                color: #6469A7;
                font-size: 26px;
                margin-top: 35px;
                .title {
                    position: relative;
                    display: flex;
                    height: 49px;
                    align-items: center;
                    font-weight: bold;
                }
                .title1 {
                    margin-top: 38px;
                }
                .text-title {
                    position: relative;
                    height: 46px;
                    text-align: center;
                    line-height: 46px;
                    margin-left: 40px;
                    padding-left: 20px;
                    &::before {
                        content: "";
                        position: absolute;
                        top: 12px;
                        left: 0;
                        width: 6px;
                        height: 22px;
                        background-image: linear-gradient(-41deg, #80FDFE 0%, #7EF3FE 15%, #64B1FF 97%);
                    }
                }
                .text {
                    flex: 1;
                }
                .btn {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 151px;
                    height: 49px;
                    background: url('https://s21.lgstatic.com/growth/activity/20210915/1631689227229.png') no-repeat;
                    background-size: 100% 100%;
                    margin-right: 40px;
                }
                .content {
                    margin-top: 10px;
                }
                .content-list {
                    display: flex;
                    color: #595959;
                    line-height: 48px;
                    font-size: 24px;
                    .icon {
                        width: 8px;
                        height: 8px;
                        background: #565659;
                        border-radius: 50%;
                        margin-left: 46px;
                        margin-top: 20px;
                        margin-right: 8px;
                    }
                    .text {
                        opacity: .7;
                        flex: 1;
                        width: 612px;
                        padding-right: 14px;
                    }
                }
                .content-list:last-child {
                    .icon {
                        background: #fff;
                    }
                }
            }
        }
        .tips-tab {
            position: absolute;
            bottom: 80px;
            right: 40px;
            color: #666;
            font-size: 12px;
        }
        .tabs-content {
            .tab-item {
                padding: 0 30px;
                box-sizing: border-box;
                margin-top: 30px;
                .tab-title {
                    position: relative;
                    font-weight: 500;
                    font-size: 24px;
                    color: #555557;
                    padding-left: 20px;
                    &::before {
                        content: "";
                        position: absolute;
                        top: 8px;
                        left: 0;
                        width: 6px;
                        height: 22px;
                        background-image: linear-gradient(82deg, #FF8645 0%, #FF1E3A 87%);
                    }
                }
                .tab-txt {
                    font-size: 20px;
                    color: #8A8A8A;
                    margin-top: 12px;
                }
                .tab-txt2 {
                    position: relative;
                    padding-left: 20px;
                    &::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 14px;
                        width: 8px;
                        height: 8px;
                        background: #565659;
                        border-radius: 50%;
                    }
                }
            }
        }
        .tab-img-wrap{
            width: 100%;
            padding: 20px 30px;
            box-sizing: border-box;
        }
        .tab-img {
            width: 50%;
            vertical-align: top;
        }

    }
    /deep/ .van-tabs__wrap{
        height: 106px;
    }
    /deep/ .van-tabs__nav {
        background: linear-gradient(329deg, #02AE96 0%, #16E4C5 100%);
        height: 106px;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    /deep/ .van-tab {
        width: 200px;
        height: 106px;
        color: #fff;
        font-size: 28px;
        font-weight: 400;
    }
    /deep/ .van-tabs__line {
        bottom: 40px;
        background: #fff;
        width: 64px;
        height: 6px;
    }
}
.section-fix {
    overflow: hidden;
    height: 320px;
}
</style>
